/**
 * @module beebee-base/lib/utility/geo
 * @description Address & geo utilities.
 */

/**
 * Converte un risultato HERE API in oggetto indirizzo
 * @param {Object} data - Dati HERE API
 * @returns {Object|null} Oggetto indirizzo normalizzato
 */
function hereToAddress(data) {
  if (!data) {
    return null;
  }
  const {
    address,
    position,
    id
  } = data;
  return {
    place_id: id,
    location_position_lat: position?.lat,
    location_position_lng: position?.lng,
    location_address_text: address?.label,
    location_address_house: address?.houseNumber,
    location_address_street: address?.street || address?.district,
    location_address_postal_code: address?.postalCode,
    location_address_city: address?.city,
    // Raw HERE `county`: the EXTENDED name ("Oristano", "Città Metropolitana di
    // Milano"). Italian addresses must store the 2-letter code instead, so every
    // caller filling an Italian address has to run this through
    // `normalizeProvinceCode` (see utility/province.js) — it is kept raw here
    // because for foreign addresses the same field holds the region/state name.
    location_address_county: address?.county,
    location_address_state: address?.state,
    location_address_country: address?.countryName,
    location_address_country_code: address?.countryCode
  };
}

export { hereToAddress };
//# sourceMappingURL=geo.js.map
